// Code review - In Progress
// Documentation - In Progress

import axios from "axios";

const ENV = window.location.hostname;
let BASE_URL = "";


BASE_URL = window.location.origin;
if (process.env.NODE_ENV === "development") {
  // BASE_URL = "http://localhost:5154";
  // BASE_URL = "https://fpai-outreach.org/api";

  BASE_URL = "http://test.fpai-outreach.org/api";

}
else {
  BASE_URL = `${BASE_URL}/api`;

  // BASE_URL = "http://localhost:5154";
}
const getToken = () => localStorage.getItem("jwtToken");

const getHeaders = (isFormData = false) => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": isFormData ? "multipart/form-data" : "application/json",
});

const IUDAPI = async (payload, apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`, payload, { headers: getHeaders() });

const BindAPI = async (apiCall) =>
  axios.get(`${BASE_URL}/${apiCall}`, { headers: getHeaders() });

const BindLocalAPI = async (apiCall) =>
  axios.get(`${BASE_URL}/${apiCall}`, { headers: getHeaders() });

const GetLocalAPI = async (payload, apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`, payload, { headers: getHeaders() });

const BindPostAPI = async (Binddata, apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`, Binddata, { headers: getHeaders() });

const ImageAPI = async (imagePayload, apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`, imagePayload, {
    headers: getHeaders(true),
  });

const LanguageTranslatorAPI = async (text, targetLangKey) =>
  axios.post(
    "https://translation.googleapis.com/language/translate/v2",
    {},
    {
      params: {
        q: text,
        target: targetLangKey,
        key: "AIzaSyBdriIoRfP0cFJI4M6ESIw4GyN82gCRqZQ",
      },
    }
  );

const authenticationAPI = async (payload, apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`, payload);

const parameterPostAPI = async (apiCall) =>
  axios.post(`${BASE_URL}/${apiCall}`);

export {
  IUDAPI,
  BindAPI,
  BindLocalAPI,
  GetLocalAPI,
  ImageAPI,
  LanguageTranslatorAPI,
  BindPostAPI,
  authenticationAPI,
  parameterPostAPI,
};
